<template>
    <span class="text" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        {{text}}
        <!--<marquee class="marquee" v-if="scroll" loop="1" scrollamount="0" behavior="alternate">{{text}}</marquee>-->
        <!--<span v-else :title="text">{{text}}</span>-->
    </span>
</template>

<script>
    export default {
        name: "lg-marquee",
        props: ['text'],
        data () {
            return {
                scroll: false,
                timeout: null
            }
        },
        methods: {
            mouseEnter () {
                this.timeout = setTimeout(() => {
                    this.scroll = true;
                }, 200)
            },
            mouseLeave () {
                clearTimeout(this.timeout);
                this.scroll = false;
            }
        }
    }
</script>

<style scoped>
    .text {
        word-break:break-all;
        overflow: hidden;
    }
</style>